export const websiteConfigurationEnum = {
    Logo: "Logo",
    HomeBanner: "HomePageBanners",
    HomeAboutUs: "HomeAboutUs",
    HomeAboutUsImage: "HomeAboutUsImage",
    VatPercent: "VatPercent",
    Discount: "Discount",
    ContactDetails: "ContactDetails",
    DeliveryOptions: "DeliveryOptions",
  };